import { render, staticRenderFns } from "./BottomMenuNote.vue?vue&type=template&id=ee267c36"
import script from "./BottomMenuNote.vue?vue&type=script&lang=js"
export * from "./BottomMenuNote.vue?vue&type=script&lang=js"
import style0 from "./BottomMenuNote.vue?vue&type=style&index=0&id=ee267c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports